module.exports = __webpack_public_path__ + "static/media/free-car-removal-toowoomba.f30e5743.png";